import TasksListTable from './TasksListTable';

export default TasksListTable;
